import React from 'react'

const Mentor = () => {
  return (
    <section
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        alignItems: 'center',
        gap: '2rem',
        padding: '2rem',
        backgroundColor: '#ffffff',
        width: '100%',
         maxWidth: '1200px',
        margin: '0 auto',
        boxSizing: 'border-box',
      }}
    >
      <div>
        <h2 style={{ marginBottom: '0.5rem', color: '#1f3d7a', fontSize: '2rem' }}>
          Our Doctor
        </h2>
        <p style={{ lineHeight: 1.7, color: '#334155', fontSize: '1rem' }}>
         Dr. Richa Arora is a renowned fertility specialist and medical director who has dedicated her career to helping couples achieve their dream of parenthood. With years of experience in reproductive medicine, she combines advanced clinical expertise with a compassionate, patient‑centered approach. Her philosophy is rooted in the belief that every journey to parenthood is unique, and she strives to provide personalized care tailored to the medical, emotional, and personal needs of each couple.
          Under her leadership, patients receive access to cutting‑edge fertility treatments, including assisted reproductive technologies, diagnostic evaluations, and holistic support designed to maximize success rates. Dr. Richa Arora is deeply committed to guiding couples through what can often be an overwhelming process, ensuring they feel supported, informed, and empowered at every stage.
          Beyond her clinical practice, she is recognized for her contributions to medical education and research, frequently sharing her insights at conferences and workshops. Her dedication extends to raising awareness about fertility health and breaking down stigmas surrounding infertility. For countless couples, Dr. Richa Arora has been more than a physician—she has been a trusted partner on their path to parenthood, offering hope, expertise, and unwavering care.
</p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
        <img
          src="/images/Doctor-min.png"
          alt="Dr. Richa Arora"
          style={{ width: '100%', maxWidth: '320px', borderRadius: '12px', objectFit: 'cover', marginBottom: '1rem' }}
        />
        <h3 style={{ margin: '0 0 0.35rem', color: '#1f3d7a' }}>Dr. Richa Arora</h3>
        <p style={{ margin: 0, color: '#334155', fontWeight: 600 }}>
          MBBS, MD (Obs and Gynae)
        </p>
      </div>
    </section>
  )
}

export default Mentor
